import Breadcrumbs from '../components/Breadcrumbs';
import Link from '../components/Link';
import AdSlot from '../components/AdSlot';
import { CONTENT_CLASSES } from '../constants/classNames';
import { ADSENSE_SLOTS, ROUTES } from '../constants/config';
import { getReactionPages } from '../data/sitePages';
import '../styles/ContentPage.css';

/**
 * List of the famous reactions, each with its own explained page.
 */
export default function ReactionsIndexPage() {
  const pages = getReactionPages();
  return (
    <article className={CONTENT_CLASSES.root}>
      <Breadcrumbs
        trail={[
          { label: 'Lab', path: ROUTES.LAB },
          { label: 'Famous reactions', path: ROUTES.REACTIONS },
        ]}
      />
      <header className={CONTENT_CLASSES.hero}>
        <h1 className={CONTENT_CLASSES.heading}>Famous chemical reactions for kids</h1>
        <p className={CONTENT_CLASSES.lead}>
          From the pop of potassium in water to the metals that make bronze and brass, here are {pages.length} of the
          most famous reactions, each explained in simple words with its equation and a safety note.
        </p>
      </header>
      <section className={CONTENT_CLASSES.section}>
        <ul className={CONTENT_CLASSES.list}>
          {pages.map(({ slug, path, reaction, first, second }) => (
            <li key={slug} className={CONTENT_CLASSES.listItem}>
              <span className={CONTENT_CLASSES.listTitle}>
                <Link to={path}>{reaction.title}</Link>
              </span>
              <span className={CONTENT_CLASSES.listDetail}>
                {first.name} + {second.name} · {reaction.productName}
              </span>
            </li>
          ))}
        </ul>
      </section>
      <AdSlot slotId={ADSENSE_SLOTS.PAGE_BOTTOM} />
    </article>
  );
}
